// src/components/home/AboutIntro.jsx
import React from "react";
import {
  Box,
  Container,
  SimpleGrid,
  Heading,
  Text,
  Stack,
  Icon,
} from "@chakra-ui/react";
import { ClipboardList, FileCheck2, Calculator } from "lucide-react";

export default function AboutIntro({
  title = "Helping taxpayers make confident decisions",
  subtitle = "We research providers, publish case studies, and explain programs like Offer in Compromise, CNC, and payment plans in plain English.",
  points = [
    {
      title: "Independent summaries",
      text: "Plain-language breakdowns of services, pricing transparency, and areas of focus.",
    },
    {
      title: "Case studies",
      text: "Real scenarios showing how different firms handle common tax problems.",
    },
    {
      title: "Educational tools",
      text: "A calculator and FAQs to understand eligibility and next steps.",
    },
  ],
  image = "/assets/home/about-hero.jpg", // kept for API compatibility
}) {
  const cardBg = { base: "white", _dark: "gray.800" };
  const border = { base: "gray.200", _dark: "whiteAlpha.300" };
  const subtle = { base: "gray.700", _dark: "gray.300" };
  const iconColor = { base: "blue.600", _dark: "blue.300" };

  // map titles to icons (fallback to ClipboardList)
  const iconMap = {
    "Independent summaries": ClipboardList,
    "Case studies": FileCheck2,
    "Educational tools": Calculator,
  };

  return (
    <Box py={{ base: 10, md: 14 }}>
      <Container maxW="6xl">
        <Heading size="lg" mb={2}>
          {title}
        </Heading>
        <Text color={subtle} mb={6}>
          {subtitle}
        </Text>

        <SimpleGrid columns={{ base: 1, md: 3 }} spacing={6}>
          {points.map((p, i) => {
            const IconComp = iconMap[p.title] || ClipboardList;
            return (
              <Box
                key={i}
                bg={cardBg}
                borderWidth="1px"
                borderColor={border}
                borderRadius="lg"
                p={6}
              >
                <Stack spacing={3}>
                  <Icon as={IconComp} boxSize={6} color={iconColor} />
                  <Heading size="md">{p.title}</Heading>
                  <Text color={subtle}>{p.text}</Text>
                </Stack>
              </Box>
            );
          })}
        </SimpleGrid>
      </Container>
    </Box>
  );
}
